import { ThunkMiddleware } from 'redux-thunk'
import {
  CARRIER_CHECKLIST_UPDATE_ACTION_TYPES,
  CARRIER_UPLOAD_DOCS_ACTION_TYPES,
} from 'utils/actions/carrier'
import { closeChecklistDialog } from '../actions/ui'
import { IStore } from '../reducers'

const { EDIT_CHECKLIST_SUCCESS } = CARRIER_CHECKLIST_UPDATE_ACTION_TYPES
const { UPLOAD_DOCUMENTS_SUCCESS } = CARRIER_UPLOAD_DOCS_ACTION_TYPES

const types = {
  [EDIT_CHECKLIST_SUCCESS]: closeChecklistDialog,
  [UPLOAD_DOCUMENTS_SUCCESS]: closeChecklistDialog,
}

export const ui: ThunkMiddleware<IStore> = store => next => action => {
  if (!Object.keys(types).includes(action.type)) return next(action)
  const {
    ui: { checklist },
  } = store.getState()

  const dialogs = {
    [EDIT_CHECKLIST_SUCCESS]: checklist,
    [UPLOAD_DOCUMENTS_SUCCESS]: checklist,
  }

  const closeDialog = types[action.type]
  const dialog = dialogs[action.type]

  /**
   * @todo Fix this middlewares logic to be type-safe
   * @see https://transfix.atlassian.net/browse/FEP-248
   * @note I added @ts-ignore here because the underlying functionality
   * seems to rely on an implementation that is not exactly in line with how the
   * types seem to work.
   *
   * The issue for this line is that `closeDialog` is always defined—according
   * to TypeScript—and therefore this condition would always be true.
   */
  // @ts-ignore
  if (closeDialog && dialog && dialog.dialogOpen) store.dispatch(closeDialog())
  return next(action)
}
